import { APCore, CONFIG_LANGUAGE_VALUES } from '@core/types';
import { default as i18n, default as i18next, TFunction } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from '@messages/en.json';
import translationES from '@messages/es.json';
import translationPT from '@messages/pt.json';
import { validateValue } from '@utils/function';

import { LOCAL_TRANSLATIONS } from './constants';

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  pt: {
    translation: translationPT,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'language',
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

export class AstroPayI18n {
  public static init(
    config?: Pick<APCore, 'language'>,
  ): Promise<TFunction<'translation', undefined>> {
    const validLanguage = validateValue(config?.language, CONFIG_LANGUAGE_VALUES, 'en');

    return i18next.init({
      lng: validLanguage,
      fallbackLng: 'en',
      resources: LOCAL_TRANSLATIONS,
      interpolation: { escapeValue: false },
    });
  }

  public static getCurrent(): string {
    return i18next.language;
  }

  public static translate(key: string, options?: Record<string, unknown>): string {
    return i18next.t(key, options ?? {});
  }
}

export default i18n;
